import { createFilterOptions } from "@mui/material";
import { Concern } from "./types";

export const filter = createFilterOptions<Concern>();
